const OPEN_KEY = "__grid-guide-visible"

let node = null

function isVisible() {
    return sessionStorage.getItem(OPEN_KEY) === "true" || false
}

function show() {
    sessionStorage.setItem(OPEN_KEY, true);

    if (node) {
        document.body.append(node)
        return
    }

    console.info("Hide grid guide with 'SHIFT + CTRL + ALT + G' shortcut.")

    let outer = document.createElement('div')
    outer.className = "fixed h-screen left-0 opacity-25 overflow-hidden pointer-events-none top-0 w-full z-50"
    outer.style.color = "#fe00d1"
    
    let inner = document.createElement('div')
    inner.className = "h-screen max-w-screen-xxl mx-auto px-xxs-16-to-xl-64 relative"
    outer.appendChild(inner)

    let innerBorder = document.createElement('div')
    innerBorder.className = "absolute border border-b-0 border-solid border-t-0 h-screen left-0 top-0 w-full"
    inner.appendChild(innerBorder)

    let grid = document.createElement('div')
    grid.className = "flex h-screen items-stretch -mx-xxs-8-to-xl-16 relative z-10"
    inner.appendChild(grid)

    for (var i = 0; i < 12; i++) {
        let col = document.createElement('div')
        col.className = "flex-auto bg-current mx-xxs-8-to-xl-16"
        grid.appendChild(col)
    }

    node = outer
    document.body.appendChild(node)
}

function hide() {
    sessionStorage.setItem(OPEN_KEY, false);
    if (node) {
        document.body.removeChild(node)
    }
};

if (isVisible()) {
    show()
}

var keyup = function (e) {
    // SHIFT + CTRL + ALT + G
    if (e.ctrlKey && e.shiftKey && e.altKey && e.keyCode == 71) {
        if (isVisible()) {
            hide()
        } else {
            show()
        }
    }
};

document.addEventListener('keyup', keyup, false);
